import { LocationStatus } from "@models/location";
import {
    OrganizationStatus,
    type GetOrganizationsQuery,
} from "@models/organization";

// The Clients list's filter chips (ruling C1, 2026-10-27). One chip is active
// at a time, held in the URL's `status` key; "All" is the absence of the key.
// Pending, Approved and Rejected list clients with at least one location in
// that status (API `locationStatus`). Suspended and Cancelled filter on the
// organization's own state (API `status`). Each chip sends exactly one of the
// two, so choosing one clears the other.
export interface ClientFilter {
    key: string;
    label: string;
    query: Pick<GetOrganizationsQuery, "status" | "locationStatus">;
}

export const CLIENT_FILTERS: ClientFilter[] = [
    {
        key: "pending",
        label: "Pending",
        query: { locationStatus: LocationStatus.Pending },
    },
    {
        key: "approved",
        label: "Approved",
        query: { locationStatus: LocationStatus.Approved },
    },
    {
        key: "rejected",
        label: "Rejected",
        query: { locationStatus: LocationStatus.Rejected },
    },
    {
        key: "suspended",
        label: "Suspended",
        query: { status: OrganizationStatus.Suspended },
    },
    // Not drawn on the mockup; kept so cancelled clients can be found (C1).
    {
        key: "cancelled",
        label: "Cancelled",
        query: { status: OrganizationStatus.Cancelled },
    },
];

// The chip a `status` URL value names, or null ("All") for none or an
// unknown value.
export const findClientFilter = (param: string | null): ClientFilter | null =>
    CLIENT_FILTERS.find(({ key }) => key === param) ?? null;
